export default {
  continue: {
    id: 'buyback_funnel_seperation_screen_continue',
    defaultMessage: 'Continue',
  },
}
